import React from 'react';
import './Disclaimer.css';

const Disclaimer = () => {
  return (
    <div>
      <div className="sticky top-0 w-full justify-between h-[40px] flex flex-row bg-[#ffec00]">
        < h1 className="heading text-center px-4">JK Tyre & Industries Ltd - Disclaimer</h1>
        <img src="/icons/jk-logo.jpeg" className="w-[80px] h-[40px] object-cover"></img>
      </div>
      <div className="disclaimer">

        {/* <h1 style={{ textAlign: 'center', fontWeight: 'bold' }}>Disclaimer</h1> */}

        <section>
          <h2 style={{ fontWeight: 'bold' }}>1. Introduction</h2>
          <p>
            The information provided by JK TYRE & INDUSTRIES LTD., Company ("we," "us," or "our") on [website URL] (the "Site") is for general informational purposes only. All information on the Site is provided in good faith; however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Site.
          </p>
        </section>

        <section>
          <h2 style={{ fontWeight: 'bold' }}>2. General Information</h2>
          <p>
            The content on this Site is for informational purposes only and should not be construed as professional advice. While we strive to provide accurate and up-to-date information, we do not guarantee that the information is always correct, complete, or current. Any reliance you place on such information is strictly at your own risk.
          </p>
        </section>

        <section>
          <h2 style={{ fontWeight: 'bold' }}>3. External Links Disclaimer</h2>
          <p>
            The Site may contain (or you may be sent through the Site) links to other websites or content belonging to or originating from third parties or links to websites and features in banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third-party websites linked through the Site or any website or feature linked in any banner or other advertising. We will not be a party to or in any way be responsible for monitoring any transaction between you and third-party providers of products or services.
          </p>
        </section>

        <section>
          <h2 style={{ fontWeight: 'bold' }}>4. Professional Advice Disclaimer</h2>
          <p>
            The Site cannot and does not contain professional advice. The information is provided for general informational and educational purposes only and is not a substitute for professional advice. Accordingly, before taking any actions based upon such information, we encourage you to consult with the appropriate professionals. We do not provide any kind of professional advice. The use or reliance of any information contained on this Site is solely at your own risk.
          </p>
        </section>

        <section>
          <h2 style={{ fontWeight: 'bold' }}>5. Limitation of Liability</h2>
          <p>
            In no event shall JK TYRE & INDUSTRIES LTD., Company, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your use or inability to use the Site; (ii) any unauthorized access to or use of our servers and/or any personal information stored therein; (iii) any interruption or cessation of transmission to or from the Site; (iv) any bugs, viruses, trojan horses, or the like that may be transmitted to or through the Site by any third party; and/or (v) any errors or omissions in any content or for any loss or damage incurred as a result of the use of any content posted, emailed, transmitted, or otherwise made available through the Site, whether based on warranty, contract, tort (including negligence), or any other legal theory, and whether or not we were advised of the possibility of such damages.
          </p>
        </section>

        <section>
          <h2 style={{ fontWeight: 'bold' }}>6. "As Is" and "As Available" Disclaimer</h2>
          <p>
            The Site is provided on an "as is" and "as available" basis. JK TYRE & INDUSTRIES LTD., Company makes no representations or warranties of any kind, express or implied, as to the operation of its services or the information, content, or materials included therein. You expressly agree that your use of the Site, its content, and any services or items obtained from us is at your sole risk.
          </p>
        </section>

        <section>
          <h2 style={{ fontWeight: 'bold' }}>7. Views Expressed Disclaimer</h2>
          <p>
            The views and opinions expressed on the Site are those of the authors and do not necessarily reflect the official policy or position of JK TYRE & INDUSTRIES LTD., Company. Any content provided by our bloggers or authors are of their opinion and are not intended to malign any religion, ethnic group, club, organization, company, individual, or anyone or anything.
          </p>
        </section>

        <section>
          <h2 style={{ fontWeight: 'bold' }}>8. Changes to the Disclaimer</h2>
          <p>
            We may update our Disclaimer from time to time. We will notify you of any changes by posting the new Disclaimer on this page. You are advised to review this Disclaimer periodically for any changes. Changes to this Disclaimer are effective when they are posted on this page.
          </p>
        </section>

        <section>
          <h2 style={{ fontWeight: 'bold' }}>9. Contact Information</h2>
          <p>
            If you have any questions about this Disclaimer, please contact us at:
          </p>
          <p>
            Email: [email address]
          </p>
          <p>
            Address: [physical address]
          </p>
        </section>
      </div>
    </div>
  );
};

export default Disclaimer;
